import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_crvCooperationLogo = _resolveComponent("crvCooperationLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showDisclaimer)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: _normalizeClass(["disclaimer text-caption", _ctx.disclaimerClass])
        }, _toDisplayString(_ctx.$t("footer.disclaimer")), 3))
      : (_openBlock(), _createBlock(_component_crvCooperationLogo, { key: 1 }))
  ]))
}